/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * baseImgPath: 图片存放地址
 *
 */
let baseUrl = '';
// let baseUrl = 'http://192-168-15-36.webvpn.xiangya.com.cn:8118'; //内网
let routerMode = 'hash';
let baseImgPath;
if (process.env.NODE_ENV == 'development') { //开发环境
    baseUrl = '/api';
    baseImgPath = '/';
} else { //生产环境
    // baseUrl = '/ehealth';
    baseUrl = '';
    baseImgPath = '../../';
}

export {
    baseUrl,
    routerMode,
    baseImgPath
}



// WEBPACK FOOTER //
// ./src/config/env.js